import { FC } from 'react';
import styled from 'styled-components';
import useSWR from 'swr';
import getPalette from 'utils/getPalette';
import Loader from './Loader';

const LoadingScreen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 500;
  background-color: white;
  display: grid;
  place-items: center;
`;

const Usage: FC = () => {
  const palette = getPalette('outlined', 'primary');
  const { data, error } = useSWR('/auth/profile');
  return !data && !error?.response ? (
    <LoadingScreen>
      <Loader size={2} palette={palette} />
    </LoadingScreen>
  ) : null;
};

export default Usage;
